import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import Image from 'bricks/Image';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function ArticleCard({
  className,
  date,
  description,
  headlineTagArticle,
  href,
  image,
  isMobile,
  title,
}) {
  const Tag = headlineTagArticle;
  return (
    <div className={cx('item', isMobile ? 'itemMobile' : '', className)}>
      <a className={cx('imageWrapper')} href={href}>
        <Image alt={title} className={cx('image')} src={image} />
      </a>
      <div className={cx('content')}>
        <div className={cx('date')}>{date}</div>
        <div className={cx('title')}>
          <a className={cx('titleLink')} href={href}>
            <Tag tagName={headlineTagArticle}>{title}</Tag>
          </a>
        </div>
        {description ?
          <div className={cx('description')}>
            <div className={cx('descriptionCrop')}>{description}</div>
          </div>
        : null}
      </div>
    </div>
  );
}

ArticleCard.defaultProps = {
  headlineTagArticle: 'div',
};

ArticleCard.propTypes = {
  className: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
  headlineTagArticle: PropTypes.string,
  href: PropTypes.string,
  image: PropTypes.string,
  isMobile: PropTypes.bool,
  title: PropTypes.string,
};
